<div *ngIf="server_level_id!=0">
    <h2>{{level['name']}}</h2>

    <table class="table">
        <tr>
            <td>Name</td><td>{{level['name']}}</td>
        </tr>
        <tr>
            <td>Short Name</td><td>{{level['level_short_name']}}</td>
        </tr>
        <tr>
            <td>Description</td><td>{{level['description']}}</td>
        </tr>
        <tr>
          <td>Ordinal Number</td><td>{{level['ordinal_number']}}</td>
      </tr>
        <tr>
            <td>Country</td><td>{{level['level_country_name']}}</td>
        </tr>
    </table>
    <div class="text-center"> Subjects</div>
    <div class="table-responsive" *ngIf="subjectList">
      <table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
          <thead>
          <tr>
          <th>Country</th>
          <th>Level</th>
          <th>Name</th>

          <th>Billing Code</th>
          <th>Syllabus</th>
          </tr>
          </thead>

          <tbody>

          <tr *ngFor="let subject of subjectList;">
              <td>{{subject.countryName}}</td>
              <td>{{subject.level}}</td>
              <td>{{subject.name}}</td>

              <td>{{subject.billingCode}}</td>
              <td>{{subject.syllabusCode}}</td>
          </tr>

          </tbody>

      </table>
      </div>



    <p class = "text-center">
        <a [routerLink]="['/admin/levels/edit',level['server_level_id']]" class="btn btn-primary mx-2">Edit</a>
        <a [routerLink]="['/admin/levels']" class="btn btn-primary mx-2">List</a>
        <button (click)="addSubjectPopUp()" class="btn btn-primary mx-2">
          <i class="fa fa-plus"></i> Add Subject
         </button>
    </p>
    </div>




   <app-admin-subject-new
   (addSubjectSaveEvent)="saveAddSubject($event)"
   (addSubjectCloseModalEvent)="closeSubjectModal()"
   [server_level_id]="server_level_id"
   [level_country_name]="level['level_country_name']"
   [level_name]="level['name']"> </app-admin-subject-new>

    <app-spinner *ngIf="server_level_id==0"></app-spinner>
